updatePaymentPage